"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HowToReplaceCarInstructionVideoWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var HowToReplaceCarInstructionVideoWidget = /** @class */ (function (_super) {
    __extends(HowToReplaceCarInstructionVideoWidget, _super);
    function HowToReplaceCarInstructionVideoWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showPopup: false
        };
        _this.toggleModal = _this.toggleModal.bind(_this);
        _this.renderPopup = _this.renderPopup.bind(_this);
        return _this;
    }
    HowToReplaceCarInstructionVideoWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "info-button-panel font-weight-light banner d-flex flex-row how-to-video-banner" },
                React.createElement("div", { className: "info-button cursor-pointer undefined" }),
                React.createElement("div", { className: "d-flex flex-column" },
                    React.createElement("div", null,
                        React.createElement("p", null, "Find out how to manually add your car viewing a short how-to video.")),
                    React.createElement("div", null,
                        React.createElement("button", { type: "button", className: "btn-link text-decoration-underline d-block border-0", onClick: this.toggleModal },
                            React.createElement("span", { className: "fa fa-solid fa-play" }),
                            "\u00A0 Play video")))),
            this.state.showPopup && this.renderPopup()));
    };
    HowToReplaceCarInstructionVideoWidget.prototype.renderPopup = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggleModal });
        return (React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.showPopup },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleModal, close: closeBtn },
                React.createElement("div", { className: "d-flex flex-row how-to-replace-car-video-popup-header" },
                    React.createElement("img", { alt: "info-icon", src: "/img/info-icon-active.svg", height: 35 }),
                    React.createElement("h1", { className: "ml-1" }, "How to replace your car"))),
            React.createElement(reactstrap_1.ModalBody, null,
                React.createElement("iframe", { className: "how-to-replace-car-video", src: "https://www.youtube.com/embed/DgUu3lV0pkA?si=2p9SppgFZIk5tUrI", title: "YouTube video player", loading: "lazy", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerPolicy: "strict-origin-when-cross-origin", allowFullScreen: true })),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement("button", { className: "btn btn-primary", type: "button", onClick: this.toggleModal }, "Ok, thanks"))));
    };
    HowToReplaceCarInstructionVideoWidget.prototype.toggleModal = function () {
        this.setState({ showPopup: !this.state.showPopup });
    };
    return HowToReplaceCarInstructionVideoWidget;
}(plugin_journey_1.WidgetBase));
exports.HowToReplaceCarInstructionVideoWidget = HowToReplaceCarInstructionVideoWidget;
//# sourceMappingURL=HowToReplaceCarInstructionVideoWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/HowToReplaceCarInstructionVideoWidget.js
// module id = 3232
// module chunks = 0